import {
  fcheck_null_undefine_replace_empty,
  fAlertToast,
} from "../../Utility/Utilitys";

import { vRdxUserInfo } from "../../Redux/roStore";
import {
  common_DcRebateDetail_GETROW,
  common_LocationSearch_GETROW,
  common_VendorListReport_GETROW,
} from "../../Server/ApiV2";

export const sWebStockReportData = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
];
export const sWebStockReportArr = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
  { Uid: "From", Value: "From" },
  { Uid: "To", Value: "To" },
  { Uid: "Between", Value: "Between" },
];
export const sWebBetweenReportArr = [{ Uid: "Between", Value: "Between" }];

export const HeadObjectInit = {
  sDate: sWebBetweenReportArr[0].Uid,
  sFromDate: new Date(),
  sToDate: new Date(),
  sLocation: "Is",
  // sLocationArr: [],
  sLocationArr: [],
  sLocationPrnt: "",
  sLocationCode: "",
  sLocationName: "",
  sDCLocation: "Is",
  sDCLocationArr: [],
  sDCLocationPrnt: "",
  sDCLocationCode: "",
  sDCLocationName: "",
  sMainSupplier: "All",
  sMainSupplierArr: [],
  sMainSupplierPrnt: "",
  sMainSupplierName: "",
  sSupplierSearchValue: "",
};

export const GetLocation = async (setLocation, setDCLocationData) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  //v_AnyData,v_Cd,v_Name,v_Distri,v_UserCd
  var vLocobj = {
    userCd: vRdxUserInfoObj.UserID,
  };
  let FinalObj = fcheck_null_undefine_replace_empty(vLocobj);
  const vLocation = await common_DcRebateDetail_GETROW(FinalObj);
  if (vLocation?.status === 200) {
    let branches = [
      { Cd: "All", Name1: "All", BranchCode: "", BranchName: "" },
      ...vLocation?.data?.ResultSet.Location,
    ];

    setLocation(branches);
    // { "Cd": "All", "Name1": "All", "BranchCode": "", "BranchName": "" },
    // setDCLocationData(vLocation?.data?.ResultSet.DCLocation);
    setDCLocationData(vLocation?.data?.ResultSet.DCLocation);
  }
};

export const fValidationHead_Client = (HeadObject, sBufferObj) => {
  let iRes = true;

  if (
    HeadObject.sFromDate === "" ||
    HeadObject.sFromDate === null ||
    HeadObject.sFromDate === undefined ||
    HeadObject.sFromDate === "Invalid Date" ||
    HeadObject.sToDate === "" ||
    HeadObject.sToDate === null ||
    HeadObject.sToDate === undefined ||
    HeadObject.sToDate === "Invalid Date"
  ) {
    fAlertToast("FAILED", "Date should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sLocation.toUpperCase() === "IS" &&
    HeadObject.sLocationPrnt === ""
  ) {
    fAlertToast("FAILED", "Location should not be empty");

    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sDCLocation.toUpperCase() === "IS" &&
    HeadObject.sDCLocationPrnt === ""
  ) {
    fAlertToast("FAILED", "DC Location should not be empty");

    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sMainSupplier.toUpperCase() === "IS" &&
    HeadObject?.sMainSupplierArr.map((x) => x.AcCd).join(",") === ""
  ) {
    fAlertToast("FAILED", "Supplier should not be empty");

    iRes = false;
    return iRes;
  }
  if (
    sBufferObj.sDetailReportRadioBtnName === "" ||
    sBufferObj.sDetailReportRadioBtnName === null ||
    sBufferObj.sDetailReportRadioBtnName === undefined
  ) {
    fAlertToast("FAILED", "Report type should not be empty");

    iRes = false;
    return iRes;
  }

  return iRes;
};

export const GetWmsStockRepotMainSupplier = async (setGroupData) => {
  const CurrentMaingroupArr = await common_VendorListReport_GETROW("");
  if (CurrentMaingroupArr?.status === 200) {
    setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  }
};
